import { useEffect, useState } from 'react';

/**
 * Returns the height (in px) of the on-screen keyboard on mobile, so callers can
 * push fixed-bottom UI (composers, action bars) above it.
 *
 * Uses window.visualViewport when available. On desktop and unsupported browsers
 * the value stays at 0 so layouts remain unchanged.
 */
export const useKeyboardInset = () => {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const vv = window.visualViewport;
    if (!vv) return undefined;

    const update = () => {
      // Distance between the bottom of the visual viewport and the bottom of the layout viewport.
      // When the keyboard opens, visualViewport.height shrinks, so this value grows.
      const bottomInset = Math.max(
        0,
        window.innerHeight - vv.height - vv.offsetTop
      );
      // Ignore tiny sub-pixel differences so we don't nudge the UI when there's no keyboard.
      setInset(bottomInset > 100 ? Math.round(bottomInset) : 0);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
};

export default useKeyboardInset;
